<template>
  <v-alert
      class="text-center"
      :value="!!alertType"
      :type="alertType">
    {{ textAlert }}
  </v-alert>
</template>

<script>
  import { ORG_REQUEST_STATUSES } from '@/constants/business'

  export default {
    props: {
      requestStatus: {
        type: String
      },
      processComment: {
        type: String
      }
    },
    computed: {
      alertType () {
        const status = this.requestStatus
        switch (status) {
        case ORG_REQUEST_STATUSES.CREATED:
        case ORG_REQUEST_STATUSES.INPROCESS:
          return 'info'
        case ORG_REQUEST_STATUSES.APPROVED:
          return 'success'
        case ORG_REQUEST_STATUSES.REJECTED:
          return 'error'
        default:
          return null
        }
      },
      textAlert () {
        const status = this.requestStatus
        switch (status) {
        case ORG_REQUEST_STATUSES.CREATED:
          return this.$t('Регистрация не завершена. Для завершения пройдите все шаги регистрации и отправьте запрос.')
        case ORG_REQUEST_STATUSES.INPROCESS:
          return this.$t('Запрос подан и находится в обработке.')
        case ORG_REQUEST_STATUSES.APPROVED:
          return this.$t('Запрос на регистрацию организации одобрен.')
        case ORG_REQUEST_STATUSES.REJECTED:
          const comment = this.processComment
            ? this.processComment
            : this.$t('не указана.')
          return this.$t('Запрос на регистрацию организации отклонен. Причина') + ': ' + comment
        default:
          return null
        }
      }
    }
  }
</script>
